import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import { ChildSelector } from "../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import * as featuresSectionStyles from "../styles/FeaturesSection.module.css"

export default function SectionWithDoubleImage(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `features-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const subTitle = ChildSelector.select(
    content,
    `features-section-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "features-section-content")
    .map(t => t.text)

  return (
    <>
      <div className={`row ${featuresSectionStyles.wrapper}`}>

        <TwoColumnHeroWithImageRight
          contentClass={featuresSectionStyles.content}
          imageHolder={content}
          imageSelector={`features-section-media`}
          imageClass={featuresSectionStyles.backgroundImage}
          className={`${props.className} ${featuresSectionStyles.innerWrapper}`}
          mode={CONTAINMENT_MODE.normal}
        >
          <div className={`${props.className} ${featuresSectionStyles.content}`}>
            <WPImage
              holder={content}
              selector={`features-section-icon`}
              mode={DISPLAY_MODE.normal}
              className={featuresSectionStyles.media}
            />
            <h1
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
            <h3
              dangerouslySetInnerHTML={{
                __html: subTitle,
              }}
            />
            {textStack.map((t, idx) => (
              <p key={idx}>{t}</p>
            ))}
          </div>

        </TwoColumnHeroWithImageRight>
      </div>
    </>
  )
}
